import React from 'react';
import styled from 'styled-components';

type IframeVideoProps = {
    className?: string;
    title?: string;
    onError: () => void;
    onReady: () => void;
    videoLink: string;
};

export const IframeVideo = ({
    className,
    title,
    onError,
    onReady,
    videoLink
}: IframeVideoProps) => {
    return (
        <_IframeVideo
            allowFullScreen
            className={className}
            onError={onError}
            onLoad={onReady}
            src={videoLink}
            title={title}
        />
    );
};

const _IframeVideo = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
